module.exports = __webpack_public_path__ + "media/images/money-back-guarantee-4c63f13a5502ccde60994e608abf8cf3.svg";